var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/screen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,14 C20,14.551 19.552,15 19,15 L12.087,15 L11.913,15 L5,15 C4.448,15 4,14.551 4,14 L4,6 C4,5.449 4.448,5 5,5 L19,5 C19.552,5 20,5.449 20,6 L20,14 Z M19,3 L5,3 C3.346,3 2,4.346 2,6 L2,14 C2,15.654 3.346,17 5,17 L11,17 L11,19 L7,19 C6.45,19 6,19.45 6,20 C6,20.55 6.45,21 7,21 L17,21 C17.55,21 18,20.55 18,20 C18,19.45 17.55,19 17,19 L13,19 L13,17 L19,17 C20.654,17 22,15.654 22,14 L22,6 C22,4.346 20.654,3 19,3 L19,3 Z",
    id: "path-1",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.b1ffcd35.svg";
export { ForwardRef as ReactComponent };